import type { ComponentPropsWithoutRef } from "react";
import { Callout } from "./Callout";
import { ComparisonTable } from "./ComparisonTable";
import { FAQAccordion } from "./FAQAccordion";
import { BlogCTA } from "../BlogCTA";

export const mdxComponents = {
  Callout,
  ComparisonTable,
  FAQAccordion,
  BlogCTA,
  h1: (props: ComponentPropsWithoutRef<"h1">) => <h1 className="dyna-prose__h1" {...props} />,
  h2: (props: ComponentPropsWithoutRef<"h2">) => <h2 className="dyna-prose__h2" {...props} />,
  h3: (props: ComponentPropsWithoutRef<"h3">) => <h3 className="dyna-prose__h3" {...props} />,
  p: (props: ComponentPropsWithoutRef<"p">) => <p className="dyna-prose__p" {...props} />,
  ul: (props: ComponentPropsWithoutRef<"ul">) => <ul className="dyna-prose__ul" {...props} />,
  ol: (props: ComponentPropsWithoutRef<"ol">) => <ol className="dyna-prose__ol" {...props} />,
  li: (props: ComponentPropsWithoutRef<"li">) => <li className="dyna-prose__li" {...props} />,
  a: (props: ComponentPropsWithoutRef<"a">) => <a className="dyna-prose__link" {...props} />,
  blockquote: (props: ComponentPropsWithoutRef<"blockquote">) => <blockquote className="dyna-prose__quote" {...props} />,
  code: (props: ComponentPropsWithoutRef<"code">) => <code className="dyna-prose__code" {...props} />,
  img: (props: ComponentPropsWithoutRef<"img">) => <img className="dyna-prose__img" loading="lazy" {...props} />,
};
